import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { ActorContextRow, truncateId } from "./ActorContextRow";

export const ApiClientActorContextTypename = "ApiClientActorContext" as const;

export const ApiClientActorContextFragment = graphql(`
  fragment ApiClientActorContextFields on ApiClientActorContext {
    __typename
    clientId
    clientName
  }
`);

interface Props {
  data: FragmentOf<typeof ApiClientActorContextFragment>;
}

export function ApiClientActorContext({ data }: Props) {
  const p = readFragment(ApiClientActorContextFragment, data);
  return (
    <ActorContextRow>
      api client {p.clientName} ({truncateId(p.clientId)})
    </ActorContextRow>
  );
}
